import { createContext, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { DrawerAgent } from "../components";
import localStorageKey from "../enumerations/localStorageKey";
import { buildSubDomain, envChangeType, envType } from "../plugins/utils";

const AgentContext = createContext({
  openDrawerAgent: () => {},
});

export const AgentContextProvider = ({ children }) => {
  const [showDrawerAgent, setShowDrawerAgent] = useState(false);
  const { t, i18n } = useTranslation();
  const getLanguage = () => i18n.language;
  const nowLang = getLanguage();
  const token = window.localStorage.getItem(localStorageKey.TOKEN);
  const currency = localStorage.getItem(localStorageKey.DEFAULT_CURRENCY);
  const domain = envChangeType("REACT_APP_SPECIAL_DIRECT", envType.BOOLEAN)
    ? buildSubDomain("agent")
    : envChangeType("REACT_APP_AGENT_MOBILE_URL");
  const agentUrl = `${domain}?token=${token}&lang=${nowLang}&currency=${currency}`;

  const openDrawerAgent = () => {
    setShowDrawerAgent(true);
  };
  return (
    <AgentContext.Provider value={{ openDrawerAgent }}>
      {children}
      <DrawerAgent
        onClose={() => {
          setShowDrawerAgent(false);
        }}
        showDrawer={showDrawerAgent}
        setShowDrawer={setShowDrawerAgent}
        title={t("personal.affiliateCenter")}
        url={agentUrl}
      />
    </AgentContext.Provider>
  );
};

export const useAgent = () => {
  const AgentValue = useContext(AgentContext);
  return AgentValue;
};
